import React from 'react';
import { PLAN_TYPES } from 'src/constants/cardsEnum';
import { Avatar, Box, SxProps, Theme, Tooltip } from '@mui/material';
import SchoolIcon from '@mui/icons-material/School';
import FREE_PLAN_PERSONA_IMG from '../../assets/freePlanPersona.png';
import BASIC_PLAN_PERSONA_IMG from '../../assets/basicPlanPersona.png';
import PRO_PLAN_PERSONA_IMG from '../../assets/proPlanPersona.png';
import styleVariables from 'src/scss/_variables.scss';
import { PRO_PLAN_INTELLIGENCE_NOTE } from 'src/constants/billing';

interface PersonaByPlanProps {
  currentPlan: string;
  sx?: SxProps<Theme>;
  sxDecoratorIcon?: SxProps<Theme>;
}

export const PersonaByPlan: React.FC<PersonaByPlanProps> = ({
  currentPlan,
  sx,
  sxDecoratorIcon,
}) => {
  let imgSrc;

  switch (currentPlan) {
    case PLAN_TYPES.FREE:
      imgSrc = FREE_PLAN_PERSONA_IMG;
      break;
    case PLAN_TYPES.BASIC:
      imgSrc = BASIC_PLAN_PERSONA_IMG;
      break;
    case PLAN_TYPES.PRO:
      imgSrc = PRO_PLAN_PERSONA_IMG;
      break;
    default:
      imgSrc = '';
      break;
  }

  return (
    <Box sx={{ position: 'relative', display: 'inline-block' }}>
      <Avatar
        src={imgSrc}
        alt={currentPlan}
        sx={{ background: styleVariables.colorWhite, ...sx }}
      />
      {currentPlan === PLAN_TYPES.PRO && (
        <Tooltip title={PRO_PLAN_INTELLIGENCE_NOTE}>
          <SchoolIcon
            sx={{
              background: styleVariables.midNighBlue,
              borderRadius: '50%',
              position: 'absolute',
              border: `1px solid ${styleVariables.premiumGold}`,
              padding: 2,
              top: 0,
              right: 0,
              width: 48,
              height: 48,
              color: styleVariables.phdIconGray,
              ...sxDecoratorIcon,
            }}
          />
        </Tooltip>
      )}
    </Box>
  );
};

export default PersonaByPlan;
